<template>
  <v-card :disabled="loading" outlined style="min-height: 400px; ">
    <v-progress-linear v-show="loading" color="primary" indeterminate></v-progress-linear>
    <v-card-title> Controle de insumos </v-card-title>
    <v-card-text v-if="!noData">
      <v-row>
        <v-col> </v-col>
        <v-col>
          <v-select
            class="ml-2"
            clearable
            :loading="loadingStages"
            :disabled="loadingStages"
            label="Etapas"
            v-model="stageSelected"
            :items="stages"
            item-value="id"
            item-text="text"
            rounded
            outlined
          ></v-select>
        </v-col>
        <v-col
          ><v-text-field
            v-model="dateSelected"
            outlined
            rounded
            type="date"
          ></v-text-field
        ></v-col>
        <v-col>
          <v-btn
            x-large
            rounded
            color="primary"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col></v-col>
        <v-col>
          <div style="width: 600px">
            <bar-chart :chart-data="chartData" :options="chartOptions" />
          </div>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else>
      <div class="text-center text-h5 mt-10 ">
        <v-icon size="64" color="grey">mdi-chart-box-outline</v-icon>
        <div class="mt-4">Nenhum dado encontrado para o gráfico de controle de insumos.</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { Bar } from "vue-chartjs";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { mapActions } from "vuex";
export default {
  components: { "bar-chart": Bar },
  data() {
    return {
        noData: false,
      dateSelected: new Date().toISOString().substr(0, 10),
      stageSelected: null,
      loadingStages: false,
      stages: [],
      costId: null,
      loading: false,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Controle de insumos",
            backgroundColor: (ctx) => {
              const colors = [
                "#fb8c00",
                "#1976d2",
                "#4caf50",
                "#e53935",
                "#8e24aa",
                "#00acc1",
                "#fbc02d",
                "#6d4c41",
                "#43a047",
                "#c62828"
              ];
              // ctx.dataIndex is available in Chart.js v3+ for scriptable options
              return colors[ctx.dataIndex % colors.length];
            },
            borderColor: "#4caf50",
            fill: true,
            data: [],
            order: 1,
          },
            // label: "Controle de insumos",
            // backgroundColor: "#fb8c00",
            // borderColor: "#4caf50",
            // fill: true,
            // data: [],
            // order: 1,
        //   },
        //   {
        //     label: "Material",
        //     backgroundColor: "#1976d2",
        //     borderColor: "#4caf50",
        //     fill: true,
        //     data: [],
        //     order: 1,
        //   },
        //   {
        //     label: "Serviços",
        //     backgroundColor: "#4caf50",
        //     borderColor: "#4caf50",
        //     fill: true,
        //     data: [],
        //     order: 1,
        //   },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  created() {

    this.loadStages();
  },
  methods: {
    ...mapActions("Dashboard", ["getChartControlInput", "getLoadStages"]),
    getData() {
      this.loading = true;
      const data = {
        stage_id: this.stageSelected,
        date: this.dateSelected,
      };
      this.getChartControlInput(data)
        .then((response) => {
          this.chartData.datasets[0].data = response.data.data;
          this.chartData.labels = response.data.labels;
          this.costId = response.data.cost_id;

        }).catch((error) => {
          if (error.response.status === 423) {
            console.log("aqui");
            this.noData = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });

      //   this.loadingStages = true;
      //   this.getLoadStages(data)
      //     .then((response) => {
      //       this.stages = response.data;
      //     })
      //     .finally(() => {
      //       this.loadingStages = false;
      //     });
    },
    loadStages() {
      //carregar as etapas
    //   this.loading = true;
      this.loadingStages = true;
      this.getLoadStages()
        .then((response) => {
          this.stages = response.data;
        //    seta o prieiro item como selecionado
          if (this.stages.length > 0) {
            this.stageSelected = this.stages[0].id;
          }
          //carregar os dados do gráfico
          this.getData();

        }).catch((error) => {
          if (error.response.status === 423) {
            this.noData = true;
          }
        })
        .finally(() => {
          this.loadingStages = false;
        });
    },
  },
};
</script>
